export const TICKET_CHECKIN_SUCCESS = 'success';
